import { useNavigate } from "react-router-dom";
import "./HeroSection2.css";
import rightArrow from "../../../../assets/img/homeV2/Right-Arrow.png";

/**
 * HeroSection — Full-width hero banner with mythology background,
 * centered title text, description, and golden CTA button.
 *
 * @param {{ plans: Object|null, plansLoading: boolean }} props
 *   plans        — response from GET /plans (country-localised). May be null.
 *   plansLoading — true while the API call is in-flight.
 */
export const HeroSection = ({ plans, plansLoading }) => {
  const navigate = useNavigate();

  // Derive localised price label purely dynamically from the API response
  const plan = plans?.plans?.[0];
  let priceLabel = null;
  if (plan?.final_price) {
    const symbol = plan.currency === "INR" ? "₹" : "$";
    if (plan.currency === "INR") {
      // e.g. "₹499/year"
      priceLabel = `${symbol}${Math.round(parseFloat(plan.final_price))} /year`;
    } else {
      // Show monthly equivalent for non-INR: annual price ÷ 12 dynamically from API
      const monthly = (parseFloat(plan.final_price) / 12).toFixed(2);
      priceLabel = `${symbol}${monthly} /month`;
    }
  }

  return (
    <section className="heroSection" id="hero-section">
      {/* Background image */}
      <img
        src={`${process.env.REACT_APP_CDN_URL}/static/homev3/Desktop+(1).png`}
        alt="India's Legends and Heroes — mythological characters"
        className="heroSection__bgImage slide_mob-dnone"
      />

      {/* Centered content */}
      <div className="heroSection__content">
        <div className="innrHeroSectn">
          <h1 className="heroSection__title">
            Teach Your <span style={{ color: "#3C9CED" }}>Child About</span>{" "}
            Indian Culture, The{" "}
            <span style={{ color: "#F3A723" }}> Fun Way.</span>
          </h1>

          <p className="heroSection__description">
            Yuva Quest turns screen time into story time, with fun stories about
            Indian heroes, legends, ancient history, and festivals that kids
            can't get enough of.
          </p>

          {/* CTA actions group */}
          <div className="heroSection__ctaGroup">
            <button
              className="heroSection__cta"
              id="hero-cta-btn"
              onClick={() => navigate("/student/start-your-quest")}
              aria-label={
                priceLabel ? `Start for ${priceLabel}` : "Start Their Journey"
              }
            >
              {plansLoading ? (
                <>
                  Start for
                  <span
                    className="heroSection__priceBadge heroSection__priceBadge--shimmer"
                    aria-hidden="true"
                  />
                </>
              ) : priceLabel ? (
                `Start for ${priceLabel}`
              ) : (
                "Start Their Journey"
              )}
              <img src={rightArrow} alt="" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
      <div>
        <img
          src={`${process.env.REACT_APP_CDN_URL}/static/homev3/Mobile+(1)+(1).png`}
          alt="India's Legends and Heroes — mythological characters"
          className="heroSection__bgImage  slidedsktop-dnone"
        />
      </div>
    </section>
  );
};
